import React, { useEffect, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import api from "../api/api";
import "../css/TherapistMilestones.css";

const therapistMessages = [
	"Great therapists don't just prescribe — they empower 💪 You're doing both!",
	"Beyond the session 🌱 That's your impact!",
	"Every program you create = more follow-through at home! 📈",
	"You're not adding activities — you're building habits! 🧠",
	"Done in session = done at home! ✔️",
	"Small actions. Big outcomes! 🚀",
];

const statConfig = {
	clients_added: {
		label: "Clients added",
		icon: "👥",
	},
	programs_created: {
		label: "Programs created",
		icon: "📋",
	},
};

const getProgressPercent = (value, nextMilestone) => {
	if (!nextMilestone || nextMilestone <= 0) {
		return 100;
	}

	return Math.min(100, Math.round((value / nextMilestone) * 100));
};

const MilestoneCard = ({ type, stat }) => {
	const config = statConfig[type];
	const value = stat?.value || 0;
	const nextMilestone = stat?.next_milestone || 1;
	const progress = getProgressPercent(value, nextMilestone);

	return (
		<div className="milestone-card">
			<div className="milestone-card-title">{config.label}</div>

			<div className="milestone-card-body">
				<div
					className="milestone-ring"
					style={{
						background: `conic-gradient(#e22e78 ${progress}%, #f8d5e5 ${progress}% 100%)`,
					}}
				>
					<div className="milestone-ring-inner" />
				</div>

				<div className="milestone-card-copy">
					<div className="milestone-value">{value}</div>
					<div className="milestone-next">
						<span
							className="milestone-next-icon"
							aria-hidden="true"
						>
							{config.icon}
						</span>

						<span>
							Next milestone: {nextMilestone}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

const TherapistMilestones = () => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchMilestones = async () => {
			try {
				const response = await api.get(
					"/therapist-milestones/",
				);

				setData(response.data);
			} catch (err) {
				console.error(
					"Error fetching therapist milestones:",
					err,
				);

				setError("Could not load milestones.");
			} finally {
				setLoading(false);
			}
		};

		fetchMilestones();
	}, []);

	if (loading) {
		return (
			<div className="therapist-milestones therapist-milestones-loading">
				<Spinner animation="border" size="sm" />
			</div>
		);
	}

	if (error) {
		return (
			<Alert variant="warning" className="mb-3">
				{error}
			</Alert>
		);
	}

	if (!data) {
		return null;
	}

	const weeklyProgramCount = data.weekly.programs_created || 0;
	const weeklyProgramLabel = weeklyProgramCount === 1 ? "program" : "programs";

	const message =
		therapistMessages[data.message_index] || therapistMessages[0];

	return (
		<div className="therapist-milestones">
			<div className="milestone-hero">
				<div className="milestone-hero-copy">
					<div className="milestone-message">
						{message}
					</div>

					<div className="milestone-weekly">
						<span className="milestone-weekly-label">This week</span>
						<span>
							{weeklyProgramCount}{" "}
							{weeklyProgramLabel} created
						</span>
					</div>
				</div>

				<div className="milestone-grid milestone-grid--open">
					<MilestoneCard
						type="clients_added"
						stat={data.stats.clients_added}
					/>

					<MilestoneCard
						type="programs_created"
						stat={data.stats.programs_created}
					/>
				</div>
			</div>
		</div>
	);
};

export default TherapistMilestones;